<template>
  <div class="relative min-h-screen min-w-screen bg-white text-gray-900 flex items-center overflow-hidden">
    <div class="absolute inset-0 p-2 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 transform -skew-y-12 scale-125 h-full lg:h-2/3 -translate-x-6 overflow-hidden">
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/plumbing-company-logo.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/easy-clean.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/padel-club.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/bootroom.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/close-shave.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/error-nogo.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/smith-graysons.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/holey-grail.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/the-angler.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/always-greener.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/proper-brewing.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/sorensa.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/austins.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/the-peveril.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/chaptters.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/eversons-electric.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/maceys-compute.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/moose-lamb.png')] bg-cover bg-center"></div>
      </div>
      <div  class="flex justify-center align-middle items-center relative bg-gradient-to-b from-white from-5% via-white/0 via-50% to-white to-80% min-w-full min-h-screen">
        <div class="rounded-lg shadow-xl h-full w-full flex bg-white/55 backdrop-blur-md flex-col justify-center items-center p-8 mx-8 gap-8 my-36 max-w-[520px]">
            <div class="relative border-2 border-blue-900 border-dashed w-full rounded-lg p-8 flex justify-center" id="dropzone">
                <input type="file" id="file-upload" accept="image/*" class="absolute inset-0 w-full h-full opacity-0 z-50" />
                <div id="instructions" class="text-center">
                    <img class="mx-auto h-12 w-12" src="https://www.svgrepo.com/show/357902/image-upload.svg" alt="">
                    <h3 class="mt-2 text-sm font-medium text-blue-900">
                        <label for="file-upload" class="relative cursor-pointer">
                            <span>Drag and drop</span>
                            <span class="text-blue-900 underline"> or browse </span>
                            <span>to upload</span>
                        </label>
                    </h3>
                    <p class="mt-1 text-xs text-blue-900">
                        PNG, JPG, GIF up to 10MB
                    </p>
                </div>

                <img src="" class="h-full w-auto mx-auto max-h-60 hidden border border-[#0079E3] shadow-lg rounded-lg" id="preview">
            </div>
            <div class="flex flex-col gap-4 w-full">
              <div class="flex justify-between align-middle items-center uppercase text-sm">
                    Company Name
                    <input id="company-name" class="p-2 rounded-lg bg-white/80 w-2/3 border border-[#0079E3] text-black" type="text" placeholder="Holey Grail">
                </div>
                <div class="flex justify-between align-middle items-center uppercase text-sm">
                    Main feature
                    <input id="main-att" class="p-2 rounded-lg bg-white/80 w-2/3 border border-[#0079E3] text-black" type="text" placeholder="Donut">
                </div>
                  <div class="flex justify-between align-middle items-center uppercase text-sm">
                      Style
                      <input id="style-input" class="p-2 rounded-lg bg-white/80 w-2/3 border border-[#0079E3] text-black" type="text" placeholder="Cartoon and fun">
                  </div>
                  <div class="flex justify-between align-middle items-center uppercase text-sm">
                      Colours
                      <input id="colour-input" class="p-2 rounded-lg bg-white/80 w-2/3 border border-[#0079E3] text-black" type="text" placeholder="Green and #FFC1CC">
                  </div>
            </div>
            <button @click="uploadFile" id="upload-button" class="w-3/4 max-w-[180px] min-h-3 shadow-xl transition ease-in-out text-white uppercase bg-[#0079E3]/80 py-2 px-4 justify-center items-center flex hover:scale-105">
              <span v-if="loading">
                  <svg
                    class="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg> <!-- You can style this as you want -->
                </span>  
              <span v-else>Create my logo</span>
            </button>
        </div>
    </div>
  </div>
</template>

<script>

export default {
name: 'Creation',
mounted() {
  const token = localStorage.getItem('authToken');

    if (!token) {
        alert('You need to log in to access this page.');
        this.$router.push('/signup');
        return;
    }

    // Validate the token with the backend
    fetch('https://1dtb961u4e.execute-api.eu-west-2.amazonaws.com/dev/validate-token', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    })
        .then((res) => {
            if (!res.ok) {
                throw new Error('Invalid or expired token');
            }
            return res.json();
        })
        .then((data) => {
            console.log('Token is valid:', data);
        })
        .catch((error) => {
            console.error('Token validation failed:', error.message);
            alert('Your session has expired. Please log in again.');
            this.$router.push('/signup');
        })
        .finally(() => {
            this.validatingToken = false; // Finish validation
        });
  const dropzone = document.getElementById('dropzone');
  const input = document.getElementById('file-upload');

  dropzone.addEventListener('dragover', this.handleDragOver);
  dropzone.addEventListener('dragleave', this.handleDragLeave);
  dropzone.addEventListener('drop', this.handleDrop);

  input.addEventListener('change', this.handleFileSelect);
},
methods: {
  handleDragOver(e) {
    e.preventDefault();
    const dropzone = document.getElementById('dropzone');
    dropzone.classList.add('border-indigo-600');
  },
  handleDragLeave(e) {
    e.preventDefault();
    const dropzone = document.getElementById('dropzone');
    dropzone.classList.remove('border-indigo-600');
  },
  handleDrop(e) {
    e.preventDefault();
    const dropzone = document.getElementById('dropzone');
    dropzone.classList.remove('border-indigo-600');
    const file = e.dataTransfer.files[0];
    this.displayPreview(file);
  },
  handleFileSelect(e) {
    e.preventDefault();
    const input = document.getElementById('file-upload');
    input.classList.remove('border-indigo-600');
    const file = e.target.files[0];
    this.displayPreview(file);
  },
  displayPreview(file) {
    if (!file) {
      alert('Please select an image file.');
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const maxWidth = 512;
        const maxHeight = 512;

        let width = img.width;
        let height = img.height;

        // Calculate the new dimensions while maintaining aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        // Create an off-screen canvas
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        // Draw the resized image onto the canvas
        ctx.drawImage(img, 0, 0, width, height);

        // Convert canvas back to file blob
        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type });

          this.selectedFile = resizedFile; // Store resized file
          const preview = document.getElementById('preview');
          preview.src = URL.createObjectURL(resizedFile);
          preview.classList.remove('hidden');
          document.getElementById('instructions').classList.add('hidden');
        }, file.type);
      };
    };

    reader.readAsDataURL(file);
  },
  async uploadFile() {
    const token = localStorage.getItem('authToken');

    if (!this.selectedFile) {
      alert('Please upload an image');
      return;
    }

    const styleInput = document.getElementById('style-input').value;
    const colourInput = document.getElementById('colour-input').value;
    const compName = document.getElementById('company-name').value;
    const mainAtt = document.getElementById('main-att').value;

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('style', styleInput);
    formData.append('colours', colourInput);
    formData.append('compname', compName);
    formData.append('attribute', mainAtt);

    this.loading = true; //show loader
    console.log("Loader state:", this.loading);

    try {
      const response = await fetch('https://1dtb961u4e.execute-api.eu-west-2.amazonaws.com/dev/inputimage', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }, 
        body: formData,
      });

      if (response.ok) {

        const apiResponse = await response.json();
        
        console.log("Full API response:", apiResponse);
        // Check if the generatedImageUrl exists in the response
      if (apiResponse) {
        console.log("Generated Image URL:", apiResponse.generatedImageUrl);
      } else {
        console.log("generatedImageUrl not found in the response.");
      }


        // Navigate to the result page
        this.$router.push({
          path: "/results",
          query: { imageUrl: apiResponse.generatedImageUrl }
        });
      } else {
        const result = await response.json();
        alert(result.error || 'Error processing the image');
      }
    } catch (error) {
      console.log('Error uploading file:', error);
    }
  },
},
data() {
  return {
    selectedFile: null,
    loading: false,
    validatingToken: true,
  }
}

};
</script>
